import { useAtomValue } from "jotai";
import { useEffect, useState } from "react";
import { TipName } from "shared/datamodel/schemas/tip";
import { userAtom, userTipsAtom, appLoadingAtom } from "state-atoms";
import { useApplyViewerRestricted } from "frontend/hooks/use-apply-viewer-restricted";

export function useBoardGridModals() {
  const user = useAtomValue(userAtom);
  const userTips = useAtomValue(userTipsAtom);
  const applyRestrictedLimitation = useApplyViewerRestricted();
  const shouldShoWRestrictedModal = !user?.isSubscribedToCanvas;
  const [showDowngradeNoticeModal, setShowDowngradeNoticeModal] = useState(false);
  const [showRestrictedNoticedModal, setShowRestrictedNoticeModal] = useState(false);
  const isAppLoading = useAtomValue(appLoadingAtom);

  useEffect(() => {
    if (user?.planInfo?.is_downgraded && user.isAdmin && !userTips.has(TipName.downgradeNotice)) {
      setShowDowngradeNoticeModal(true);
    }
    if (
      applyRestrictedLimitation &&
      !userTips.has(TipName.restrictedUsersNotice) &&
      shouldShoWRestrictedModal &&
      !isAppLoading
    ) {
      setShowRestrictedNoticeModal(true);
    }
  }, [
    userTips,
    applyRestrictedLimitation,
    shouldShoWRestrictedModal,
    user?.isAdmin,
    user?.planInfo?.is_downgraded,
    isAppLoading,
  ]);

  return {
    showDowngradeNoticeModal,
    showRestrictedNoticedModal,
    setShowDowngradeNoticeModal,
    setShowRestrictedNoticeModal,
  };
}
